import React, { useContext } from 'react';
import { AppContext, DispatchContext } from '../AppContext';
import { makeStyles } from '@material-ui/styles';
import Logo from '../assets/plagaware-logo-lightblue-150.png';
import { datePickerDefaultProps } from '@material-ui/pickers/constants/prop-types';

export default function PlagAwareLogo(props) {

    const { logoClickUrl } = props;

    const useStyles = makeStyles(theme => ({
        root: {
            position: "absolute",
            top: "20px",
            left: "20px",
            cursor: logoClickUrl ? "pointer" : "default"
        },
    }));

    const dispatch = useContext(DispatchContext);
    const state = useContext(AppContext);
    const s = state.strings;
    const classes = useStyles();

    const onLogoClicked = () => {
        window.location.href = logoClickUrl;
    }

    return (
        <div className={classes.root}>
            <img src={Logo} onClick={onLogoClicked} />
        </div>
    );
}
